var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    workpacke-info-body
    ${_vm.color}
    ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}
    font-weight-light
    `,style:(`
    ${_vm.info_box?'height: calc(60vmin - 36px);':''}
    ${_vm.info_box?'max-height: 364px;':''}
    ${_vm.wallet?'border-radius: 0px 0px 10px 10px; padding: 0px 3px 0px 3px;':''}
    color: ${_vm.textcolor};
  `)},[_vm._t("dialogs"),_vm._t("body-content",null,{"workpackage":_vm.workpackage,"work_card":_vm.work_card,"quality_card":_vm.quality_card,"defect_card":_vm.defect_card,"handover_card":_vm.handover_card,"logistic_card":_vm.logistic_card,"design_card":_vm.design_card}),_c('div',{staticClass:"workpackage-info-buttons"},[_vm._t("buttons",null,{"workpackage":_vm.workpackage})],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }